import Api from './Api'

export default {
    getGeneral() {
        return Api().get(`progress/general`);
    },
    getOne(id) {
        return Api().get(`progress/${id}`);
    }
}